import styled from 'styled-components';
import {devices} from '../../../utils/styled/_variables.styled';
import {InfiosButton} from '../../Button/Button.style';

export const InfiosSendEmailMandatory = styled.form`
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .aem-container{
      width: 100%;
    }

    .nt {
        display: none;
    }

    .privacy-checkbox {
        width: 24px;
    }

    .mandatory-form,
    .optional-form {
        width: 100%;
        max-width: 531px;

        > span {
            display: flex;
            margin-bottom: 32px;

            @media ${devices.tabletToDesktop} {
                margin-bottom: 24px;
            }

            @media ${devices.mobile} {
                margin-bottom: 20px;
            }
        }

        div + div {
            margin-top: 24px;

            &.checkbox {
                margin-top: 24px;
                align-items: baseline;

                label {
                    align-items: center;
                    display: inline;

                    a {
                        /* margin-left: 4px; */
                        display: inline;
                        font-weight: 300;
                        text-decoration: underline;
                    }
                }
                @media ${devices.tabletLarge} {
                    margin-top: 28px;
                }

                @media ${devices.mobile} {
                    margin-top: 24px;
                }

            }

            @media ${devices.tabletLarge} {
                margin-top: 28px;
            }

            @media ${devices.mobile} {
                margin-top: 24px;
            }
        }

        @media ${devices.mobileToDesktop} {
            max-width: 100%;
        }
    }

    .optional-form {
        margin-left: 145px;

        @media ${devices.mobileToDesktop} {
            margin-left: 0;
        }

        @media ${devices.tabletToDesktop} {
            margin-top: 64px;
        }

        @media ${devices.mobile} {
            margin-top: 56px;
        }
    }

    .form__captcha{
        width: 100%;
        max-width: 531px;
        @media ${devices.mobileToDesktop} {
            max-width: 100%;
        }
    }

    ${InfiosButton} {
        width: 100%;
        max-width: 531px;
        margin-top: 40px;

        @media ${devices.tabletToDesktop} {
            margin-bottom: 24px;
        }

        @media ${devices.mobile} {
            margin-bottom: 24px;
        }

        @media ${devices.mobileToDesktop} {
            max-width: 100%;
        }
    }
`
